import { render, staticRenderFns } from "./Comprobantes.vue?vue&type=template&id=536fa652&"
import script from "./Comprobantes.vue?vue&type=script&lang=js&"
export * from "./Comprobantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports